
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { FaqsList, Faq } from './faq';

interface ProductFaqsProps {
  faqs: Faq[];
  setFaqs: (faqs: Faq[]) => void;
}

const ProductFaqs = ({ faqs, setFaqs }: ProductFaqsProps) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const addNewFaq = () => {
    const newFaq = {
      id: crypto.randomUUID(),
      question: '',
      answer: '',
      visible: true,
    };
    setFaqs([...faqs, newFaq]);
  };

  const updateFaq = (id: string, field: keyof Faq, value: any) => {
    setFaqs(
      faqs.map((faq) =>
        faq.id === id ? { ...faq, [field]: value } : faq
      )
    );
  };

  const removeFaq = (id: string) => {
    setFaqs(faqs.filter((faq) => faq.id !== id));
  };

  const toggleVisibility = (id: string) => {
    setFaqs(
      faqs.map((faq) =>
        faq.id === id 
          ? { ...faq, visible: faq.visible === false ? true : false } 
          : faq
      )
    );
  };

  return (
    <div className="bg-white dark:bg-[#1a1a2e] border border-gray-200 dark:border-gray-800 rounded-lg shadow-sm">
      <div className="p-4 sm:p-6">
        <Collapsible
          open={isExpanded}
          onOpenChange={setIsExpanded}
          className="space-y-4"
        >
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-medium text-gray-900 dark:text-white">FAQs du produit</h3>
            <CollapsibleTrigger asChild>
              <Button variant="ghost" size="sm" className="text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800">
                {isExpanded ? "Masquer" : "Afficher"}
              </Button>
            </CollapsibleTrigger>
          </div>

          <CollapsibleContent className="space-y-4">
            <FaqsList
              faqs={faqs}
              updateFaq={updateFaq}
              removeFaq={removeFaq}
              toggleVisibility={toggleVisibility}
              addNewFaq={addNewFaq}
            />
          </CollapsibleContent>
        </Collapsible>
      </div>
    </div>
  );
};

export default ProductFaqs;
